export default __webpack_public_path__ + "static/media/h8.6e83c627.jpg";